import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Table from './table';
import Widget from '../../widget';
import { getLocales } from '../../../../components/Table/newTable';

const CorrectiveMeasures = ({
  data = { data: {}, sections: {}, options: {} },
  sidebarCollapsed = false,
  locationId = '',
  mod = '',
  mode = '',
  loading,
  sourceId,
  isOwnData,
}) => {
  const { t } = useTranslation();

  return (
    <Widget
      title={t('Corrective Measures')}
      tooltip={t("Records of proposed risk mitigation measures and their implementation status")}
      className="full-header no-px-body no-pb-header"
      loading={loading}
    >
      <Style>
        <Table
          locale={getLocales(t)}
          t={t}
          mode={mode}
          data={data.data}
          sections={data.sections}
          mod={mod}
          sourceId={sourceId}
          locationId={locationId}
          sidebarCollapsed={sidebarCollapsed}
          isOwnData={isOwnData}
          options={data.options}
        />
      </Style>
    </Widget>
  )
};

export default CorrectiveMeasures;
